module.exports = __webpack_public_path__ + "img/sch5-img.d76c27ef.png";